import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import {
    GarageDoorGrooveId,
    GarageDoorOpeningId,
} from '@core/constants/Shape';
import { MaterialId } from '@core/constants/Material';
import FieldDimensionId from '@core/constants/FieldDimension';
import { GarageDoorOptionsId } from '@core/constants/Option';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
    IDimensionUnit,
    IFormInputType,
} from '../../interfaces/Form';
import additionalDataFactory from './common/fieldsAdditionalData';
import fieldsContact from './common/fieldsContact';
import {
    getMaterialsWithExceptions,
    allSolidWoods,
    allMetals,
    allPlastics,
} from './common/materialGroups';

const garageDoorForm: IForm = {
    formId       : PublishedFormId.GarageDoor,
    type         : FormTypeId.Door,
    thumbnailURL : '/resized-images/forms/garageDoor.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.GarageDoorOpening,
        IFormFieldKey.Material,
        IFormFieldKey.GarageDoorGroove,
        IFormFieldKey.Dimension,
        IFormFieldKey.GarageDoorGate,
        IFormFieldKey.GarageDoorOptions,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        garageDoorOpening: {
            value   : undefined,
            options : [
                GarageDoorOpeningId.RoolUpDoor,
                GarageDoorOpeningId.SectionalDoor,
                GarageDoorOpeningId.SlidingDoor,
                GarageDoorOpeningId.SwingDoor,
                GarageDoorOpeningId.TiltingDoor,
            ],
            required: true,
        },
        material: {
            material: {
                value   : undefined,
                options : getMaterialsWithExceptions(
                    [
                        ...allSolidWoods,
                        ...allMetals,
                        ...allPlastics,
                    ],
                    [
                        MaterialId.BlackLocust,
                        MaterialId.Iroko,
                        MaterialId.Douglas,
                        MaterialId.Redcedar,
                        MaterialId.Larch,
                        MaterialId.Padouk,
                        MaterialId.Ipe,
                        MaterialId.Poplar,
                        MaterialId.DriftWood,
                        MaterialId.WagonfloorDark,
                        MaterialId.WagonfloorLight,
                        MaterialId.OakOld,
                        MaterialId.Walnut,
                        MaterialId.AshOlive,
                        MaterialId.Chestnut,
                        MaterialId.Mahogany,
                        MaterialId.Elm,
                        MaterialId.Alderwood,
                        MaterialId.Birch,
                        MaterialId.Maple,
                        MaterialId.Teak,
                        MaterialId.Ebony,
                        MaterialId.Spruce,
                        MaterialId.Rubber,
                        MaterialId.Garapa,
                        MaterialId.Rust,
                        MaterialId.Brass,
                        MaterialId.SheetMetal,
                        MaterialId.StainlessSteel,
                        MaterialId.Zinc,
                        MaterialId.PlexiglassFluorescent,
                        MaterialId.PlexiglassFrosted,
                        MaterialId.PlexiglassMirror,
                        MaterialId.PlexiglassTransparent,
                        MaterialId.PlexiglassWhite,
                        MaterialId.PolycarbonateOpaque,
                        MaterialId.PolycarbonateTeinted,
                        MaterialId.PolycarbonateTransparent,
                        MaterialId.RecycledPlastic,
                    ],
                ),
                required: true,
            },
        },
        garageDoorGroove: {
            value   : undefined,
            options : [
                GarageDoorGrooveId.Horizontal,
                GarageDoorGrooveId.Vertical,
                GarageDoorGrooveId.Molding,
            ],
            required: true,
        },
        dimension: {
            [FieldDimensionId.Length]: {
                value        : undefined,
                type         : IFormInputType.Range,
                unit         : IDimensionUnit.Centimeters,
                step         : 10,
                range        : { min: 1000, max: 4000 },
                required     : true,
                defaultValue : 2500,
            },
            [FieldDimensionId.Height]: {
                value        : undefined,
                type         : IFormInputType.Range,
                unit         : IDimensionUnit.Centimeters,
                step         : 10,
                range        : { min: 1000, max: 4000 },
                required     : true,
                defaultValue : 2200,
            },
        },
        garageDoorGate: {
            value: undefined,
        },
        garageDoorOptions: {
            value   : undefined,
            options : [
                GarageDoorOptionsId.GarageDoorMotorization,
                GarageDoorOptionsId.GarageDoorBlinker,
                GarageDoorOptionsId.None,
            ],
            required: true,
        },
        additionalData: additionalDataFactory({
            budgetMin          : 2000,
            budgetMax          : 10000,
            budgetDefaultValue : 4500,
            budgetStep         : 500,
        }),
        contact: fieldsContact,
    },
};

export default garageDoorForm;
